import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "center-wrap" }
const _hoisted_2 = { class: "left-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "block"
}
const _hoisted_4 = { class: "block profile-balance" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "balance-title" }
const _hoisted_7 = { class: "balance-value" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "block-header" }
const _hoisted_10 = { class: "header-title" }
const _hoisted_11 = {
  href: "https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url",
  target: "_blank",
  class: "header-right where-btn"
}
const _hoisted_12 = { class: "right-text" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "content-title" }
const _hoisted_16 = { class: "content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MiniProfile = _resolveComponent("MiniProfile")!
  const _component_DepositBtn = _resolveComponent("DepositBtn")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.mobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_MiniProfile, {
              id: _ctx.user.id,
              avatar: _ctx.user.avatar,
              username: _ctx.user.name,
              class: "block-profile"
            }, null, 8, ["id", "avatar", "username"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: require('../../assets/icons/balance.svg'),
          class: "balance-icon"
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('Profile.balance')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.balanceUsd), 1),
        _createVNode(_component_DepositBtn, {
          size: 24,
          class: "balance-btn"
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('Profile.link')), 1),
          _createElementVNode("a", _hoisted_11, [
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              class: "right-icon"
            }, [
              _createElementVNode("g", null, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M5 2C5.55228 2 6 2.44772 6 3C6 3.51284 5.61396 3.93551 5.11662 3.99327L5 4C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V11C4 11.5128 4.38604 11.9355 4.88338 11.9933L5 12H11C11.5128 12 11.9355 11.614 11.9933 11.1166L12 11C12 10.4477 12.4477 10 13 10C13.5523 10 14 10.4477 14 11C14 12.5977 12.7511 13.9037 11.1763 13.9949L11 14H5C3.40232 14 2.09634 12.7511 2.00509 11.1763L2 11V5C2 3.34315 3.34315 2 5 2ZM13 2L13.081 2.003L13.2007 2.02024L13.3121 2.04974L13.4232 2.09367L13.5207 2.146L13.6168 2.21279L13.7071 2.29289L13.8037 2.40469L13.8753 2.51594L13.9063 2.5769L13.9401 2.65835L13.9642 2.73401L13.9931 2.8819L14 3V7C14 7.55228 13.5523 8 13 8C12.4477 8 12 7.55228 12 7V5.414L9.70711 7.70711C9.34662 8.06759 8.77939 8.09532 8.3871 7.7903L8.29289 7.70711C7.93241 7.34662 7.90468 6.77939 8.2097 6.3871L8.29289 6.29289L10.584 4H9C8.44772 4 8 3.55228 8 3C8 2.44772 8.44772 2 9 2H13Z",
                  fill: "currentColor"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('Profile.where')), 1)
          ])
        ]),
        _createVNode(_component_InputIcon, {
          class: "input-wrap input-tradelink",
          placeholder: _ctx.t('Profile.linkPlaceholder'),
          modelValue: _ctx.tradelink,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tradelink) = $event)),
          onEnter: _ctx.saveTradelink,
          ref: "inputTradelink"
        }, {
          default: _withCtx(() => [
            (_ctx.tradelinkSet)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('../../assets/icons/check.svg'),
                  class: "icon check-icon"
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["placeholder", "modelValue", "onEnter"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t('Profile.title')), 1),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_view, {
          class: _normalizeClass(["view-wrap", { mobile: _ctx.mobile }]),
          onTradelinkError: _ctx.tradelinkError
        }, null, 8, ["class", "onTradelinkError"])
      ])
    ])
  ]))
}